import { AppBar, Box as MuiBox, Button, Toolbar } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';
import Box from 'react-layout-components';
import { useHistory } from 'react-router-dom';

import useTranslation from '../../components/hooks/useTranslation';
import { AppGuestIcon } from '../../components/icons/icons';
import HorizontalButterLogo from '../../components/logos/HorizontalButterLogo';
import * as routes from '../../constants/RouterConstants';
import styles from './Footer.styles';

type Props = WithStyles<typeof styles>;

function Footer({ classes }: Props) {
  const history = useHistory();
  const translatedStrings = useTranslation();

  return (
    <AppBar position="static" color="secondary">
      <Toolbar className={classes.footer}>
        <Box alignItems="center" height="100%">
          <Box className={classNames(classes.logoWrapper, classes.footerItem)}>
            <HorizontalButterLogo />
          </Box>
          <Box className={classes.divider} />
          <a href={routes.FOR_GUESTS_URL} target="_blank" rel="noopener noreferrer">
            <Button color="primary" className={classes.footerItem}>
              <AppGuestIcon className={classes.placeIconButton} />
              {translatedStrings.websiteForGuestsLink}
            </Button>
          </a>
        </Box>
        <MuiBox flex="1 1 auto" sx={{ display: { xs: 'none', md: 'flex' } }} justifyContent="center">
          <Box center flex="1 1 auto">
            <Button onClick={() => history.push(routes.TERMS_AND_CONDITIONS_URL)} color="primary" className={classes.footerItem}>
              {translatedStrings.termsAndConditionsLink}
            </Button>
            <Button onClick={() => history.push(routes.PRIVACY_URL)} color="primary" className={classes.footerItem}>
              {translatedStrings.privacyLink}
            </Button>
          </Box>
        </MuiBox>
      </Toolbar>
    </AppBar>
  );
}

export default withStyles(styles)(Footer);
